import React, { useState } from 'react';
import {
  EducationPlaceholderIcon,
  EducationUtils,
  CondensedHeader,
  Gutter,
  IconButton,
  useApi,
  Layout,
} from '@axiom/ui';
import type { Candidate, CandidateRedux, Education } from '@axiom/validation';

import { EducationForm } from '../EducationForm/EducationForm';
import { EducationItem } from '../EducationItem/EducationItem';
import NoContentPlaceholder from '../NoContentPlaceholder/NoContentPlaceholder';
import { CandidateApi } from '../../api/candidate-api';
import { UserApi } from '../../api/user-api';

export interface EducationListProps {
  candidate: CandidateRedux | Candidate;
  name: string;
}

export const EducationList = ({ candidate, name }: EducationListProps) => {
  const [{ data: user }] = useApi(UserApi.readSessionUser());
  const [showEducationForm, setShowEducationForm] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState<Education | null>(
    null
  );
  return (
    <Gutter name={name} top="16px">
      <Layout position="space-between middle">
        <CondensedHeader>Education</CondensedHeader>
        <IconButton
          icon="plus"
          pattern="secondary"
          variation="minimal"
          name="ADD_EDUCATION_BUTTON"
          onClick={() => {
            setShowEducationForm(true);
          }}
        />
      </Layout>

      {showEducationForm ? (
        <EducationForm
          name="EDUCATION_ITEM"
          refreshData={async () => {
            await CandidateApi.refreshCandidate({ candidateId: candidate.id });
          }}
          candidateId={candidate.id}
          onClose={() => {
            setShowEducationForm(false);
            setSelectedEducation(null);
          }}
          education={selectedEducation}
        />
      ) : null}

      {candidate.degrees && candidate.degrees.length > 0 ? (
        EducationUtils.sortDisplay(candidate.degrees).map(education => (
          <EducationItem
            key={education.id}
            name="EDUCATION_ITEM"
            user={user}
            education={education}
            candidate={candidate}
            onEdit={() => {
              setSelectedEducation(education);
              setShowEducationForm(true);
            }}
          />
        ))
      ) : (
        <NoContentPlaceholder
          image={<EducationPlaceholderIcon />}
          title="No Education"
          text="Add your education and qualifications."
        />
      )}
    </Gutter>
  );
};
